'use strict';

const LAST_OFFER_MESSAGE_STORAGE = 'sa_last_offer_message';

export default function f(localStorage) {
  'ngInject';

  return {
    saveMessage: function (message) {
      localStorage.set(LAST_OFFER_MESSAGE_STORAGE, message);
    },
    getMessage: function () {
      var message = localStorage.get(LAST_OFFER_MESSAGE_STORAGE);

      return message;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/components/trips/trips/send_offer_modal/last_offer_message.js